{
	"calculator": {
		"calculate-price": "Reiknaðu hvað kostar að senda sendingu",
		"choose-service": "Veldu þjónustu",
		"pdf-pricetable": "Prentvæn verðskrá",
		"register-shipment": "Skrá sendingu"
	},
	"shared": {
		"choose": "Veldu",
		"conformation": "Staðfesta",
		"customs": "Tollur",
		"information": "Upplýsingar",
		"max10": "Má ekki vera lengra en 10 stafir",
		"next-step": "Næsta skref",
		"onlyNumbers": "Aðeins tölustafir leyfilegir",
		"optional-services": "Viðbótarþjónustur",
		"otherPerson": "Annar",
		"overview": "Yfirlit",
		"previous-step": "Fyrra skref",
		"receipt": "Kvittun",
		"recipient": "Viðtakandi",
		"required": "Skylda að fylla út",
		"sender": "Sendandi",
		"shipment": "Sending",
		"submit": "Staðfesta",
		"type": "Tegund",
		"sales-push": "Skráðu sendanda og viðtakanda",
		"postbox": "Póstbox: Skráðu þig á <0>Mínar síður</0> og færðu inn kortaupplýsingar áður en þú skráir sendinguna hér.",
		"postoffice": "Pósthús: Við mælum með að þú skráir þig inn á <0>Mínar síður</0> áður en lengra er haldið og færir inn kortaupplýsingar. En einnig er hægt að greiða fyrir sendinguna á pósthúsi.",
		"thenWhat": "Hvað svo?",
		"li1": "Þú þarft ekki að prenta merkingar fyrir fram því það er hægt að gera það bæði á pósthúsinu og í póstboxinu.",
		"li2": "Þú þarft hvorki að vita stærð né þyngd sendingarinnar áður en þú skráir hana.",
		"li3": "Þegar þú ert búin(n) að skrá sendinguna þína getur þú farið með hana á póstbox eða í pósthús.",
		"howToSend": "Hvernig viltu senda?",
		"success-title": "Takk fyrir!",
		"success-message": "Þín endurgjöf hefur verið móttekin.",
		"registrationQuestion": "Hvernig fannst þér skráningarferlið?",
		"wwiii": "Flug til Ísrael, Íran og Írak liggur niðri og tafir geta orðið á póstsendingum til nálægra landa af þeim sökum."
	},
	"step-conformation": {
		"total-value": "Verðmæti",
		"country": "Land",
		"error": "Eitthvað fór úrskeiðis, ekki tókst að skrá sendingu.",
		"no-optional-services": "Engar viðbótarþjónustur valdar",
		"number-of-parcels": "Fjöldi pakka í sendingu?",
		"overview": "Yfirlit",
		"postbox": "Póstbox",
		"price": "Áætlað verð",
		"shipment": "Sending",
		"type": "Tegund sendingar",
		"who-pays": "Hver greiðir?",
		"approve-card-charge": "Ég samþykki að sendingargjald sé gjaldfært af skráðu greiðslukorti eftir að pakki hefur verið mældur og vigtaður.",
		"card-charge-info": "Ef samþykki er ekki veitt má greiða fyrir sendinguna á pósthúsi.",
		"register-card": "ATH: Þessa sendingu verður að póstleggja á pósthúsi. Ef þú vilt póstleggja hana í póstboxi þarftu að bæta við greiðslukorti.",
		"addPaymentCard": "Til að senda með póstboxi þarftu að færa inn kortaupplýsingar á Mínum síðum áður en þú skráir sendinguna.",
		"use-post-office": "Til að póstleggja sendinguna á pósthúsi skaltu smella á staðfesta hér fyrir neðan.",
		"company-info": "Fyrirtæki í þjónustu geta sent sendingar með bílstjóra sem kemur og sækir.",
		"attention-card": "Athugaðu, greiðsluupplýsingar vantar til að senda með póstboxi. <0>Smelltu hérna til að að skrá greiðslukort.</0>",
		"no-approval": "Ef ekki er veitt samþykki þarf að greiða fyrir sendinguna á næsta pósthúsi.",
		"post-office-option": "Ef þú ætlar að póstleggja á pósthúsi getur þú valið staðfesta.",
		"return-type-label": "Tegund skila",
		"return-type-placeholder": "Veldu tegund skila",
		"return-type-required": "Tegund skila vantar",
		"return-order-id-label": "Pöntunarnúmer",
		"return-order-id-helper-text": "Sláðu inn pöntunarnúmerið frá Metta. Ef þetta var gjöf þá hefur fylgt með skilamiði með pöntunarnúmerinu.",
		"return-order-id-placeholder": "Sláðu inn pöntunarnúmerið",
		"return-order-id-required": "Pöntunarnúmer vantar",
		"return-order-id-positive": "Pöntunarnúmer getur eingöngu verið jákvæð tala",
		"return-reason-label": "Viltu koma einhverju öðru á framfæri?",
		"return-reason-swap-label": "Hvaða vöru viltu í staðinn?",
		"return-reason-helper-text": "Ef þú ert að skipta yfir í aðra vöru þarftu að slá inn hvaða vöru þú vilt fá í staðinn, lit og stærð. Við mælum með því að afrita vefslóðina á nýju vörunni og setja hér í lýsingu.",
		"return-reason-required": "Ástæða skila vantar",
		"return-reason-placeholder": "Sláðu inn nánari upplýsingar",
		"return-reason-swap-placeholder": "Afritaðu hlekk af vörunni sem þú vilt í staðinn ásamt lit og stærð",
		"return-product-label": "Hvaða vöru ertu að skila?",
		"return-product-placeholder": "Skrifaðu nafn vöru hér",
		"return-product-helper-text": "Skráðu nafnið á vörunni sem á að skila, má skrá fleiri en eina vöru. Ef þú ert að skila allri pöntuninni getur þú skrifað \"Öllu\"",
		"return-product-required": "Vöruheiti vantar",
		"return-options": {
			"gift-credit": "Gjöf- fá inneignarnótu",
			"gift-swap": "Gjöf- skipta í aðra vöru",
			"return-credit": "Vöruskil- fá inneignarnótu",
			"return-swap": "Vöruskil- skipta í aðra vöru"
		},
		"return-cancel-button": "Fara til baka",
		"return-cancel-button-text": "Þetta er skráningarsíða fyrir vöruskil hjá Metta Sport. Ef þú ert ekki að skila vöru, veldu að fara til baka."
	},
	"step-export": {
		"add-item": "Eru fleiri hlutir í sendingunni?",
		"amount-must-be-a-numer": "Tollvirði verður að vera tölustafur",
		"value-greater-then-zero": "Verðmæti má ekki vera 0",
		"battery": "batterý",
		"cant-deliver": "Ef sending kemst ekki til skila",
		"commercial-sample": "Sýnishorn",
		"content": "Innihald",
		"content-placeholder": "Innihaldslýsingin þarf að vera skrifuð á ensku og aðeins einn hlutur í línu",
		"content-example": "Ef pakki inniheldur t.d. þrjá hluti, Shoes, pyjamas og hat má ekki skrifa alla hlutina í eina línu. “Shoes” þarf að fara í fyrstu línuna og síðan er valið “Eru fleiri hlutir í pakkanum?“ og bæta við línu fyrir “pyjamas” og þriðju línuna fyrir “hat” (ekki skrifa gjöf).",
		"count-must-be-a-number": "Fjöldi verður að vera tala",
		"count-greater-then-zero": "Fjöldi getur minnst verið einn",
		"currency": "Gjaldmiðill",
		"currency-choose": "Veldu gjaldmiðil",
		"dangerous": "Enginn hættulegur varningur er í sendingunni",
		"dangerous-link": "Hættulegur varningur",
		"dangerous-not-allowed": "Bannað er að senda hættulegan varning",
		"destroy": "Farga sendingu",
		"documents": "Skjöl",
		"exampleOfDangerousGoods": "Dæmi um vörur sem teljast hættulegur varningur",
		"lithiumWarning": "Athugið að ekki er hægt að senda lithíum rafhlöður til viðkomandi lands.",
		"field-required": "Skylda að fylla út",
		"gift": "Gjöf",
		"info": "Upplýsingar til tollayfirvalda",
		"more-info": "Sendandi ber fulla ábyrgð á öllum skráðum upplýsingum, þar á meðal innihaldi, verðmæti, HS-kóða og öðrum upplýsingum sem notaðar eru við tollafgreiðslu. Ekki er hægt að breyta upplýsingum eftir að sending hefur farið úr landi.",
		"more-items": "Eru fleiri hlutir í pakkanum?",
		"other": "Annað",
		"package": "Tegund sendingar",
		"package-choose": "Veldu tegund",
		"perfume": "ilmvatn",
		"product": "Söluvara",
		"quantity": "Fjöldi hluta",
		"quantityPlaceholder": "Fjöldi",
		"return": "Endursenda til mín",
		"returnGoods": "Endursent",
		"sprayCan": "spreybrúsi",
		"total-price": "Heildarverðmæti",
		"unit-price": "Verðmæti",
		"weight": "Þyngd",
		"total-weight": "Heildarþyngd",
		"weight-must-be-a-number": "Þyngd verður að vera tölustafur",
		"weight-greater-then-zero": "Þyngd verður að vera meiri en 0",
		"returnPolicy": "Ef afhending mistekst?",
		"chooseFromList": "Veldu úr lista",
		"messageUSA": "ATH. Vegna sendinga til Bandaríkjanna. Einungis er hægt að skrá hefðbundin bréf eða pakka sem innihalda skjöl eða gjafir (að hámarksvirði 100USD).",
		"dangerousGoods": "Ég hef lesið upplýsingar í",
		"dangerousGoods2": "viðskiptaskilmálum",
		"dangerousGoods3": "um hættuleg efni og staðfesti að engin hættuleg efni eru í sendingunni.",
		"usaTerms": "Ég hef lesið og samþykki",
		"usaTerms2": "viðskiptaskilmála",
		"usaTerms3": "varðandi sendingar til Bandaríkjanna.",
		"usaSenderInformation": "<0>ATH  Ef bandarísk yfirvöld telja að greiða þurfi aðflutningsgjöld af sendingunni áður en hún er afhent eða upplýsingarnar um innihald ekki vera réttar mun allur kostnaður falla á sendanda.</0>  Sendandi ber alla ábyrgð á því að réttar upplýsingar séu skráðar fyrir innihaldi og verðmæti sendingar til Bandaríkjanna samkvæmt nýjum tollalögum bandarískra stjórnvalda. Við mælum því með að farið sé vandlega yfir viðskiptaskilmála.",
		"terms": "Skilmálar",
		"customsInfoHeader": "Tollaupplýsingar",
		"header": "Upplýsingar til tollayfirvalda og skilmálar",
		"chooseCountry": "Veldu upprunaland",
		"countryPlaceholder": "Land",
		"countryOfOrigin": "Upprunaland",
		"insert-item": "Bæta við hlut hér",
		"hsCodeLookup": {
			"title": "Finndu tollflokk fyrir hlut",
			"manualTitle": "Handskráðu tollanúmer fyrir hlut",
			"change": "Breyta",
			"namePlaceholder": "Dæmi: Cotton shirt",
			"nameLabel": "Lýsing á ensku",
			"searchLabel": "Leit",
			"searchPlaceholder": "Dæmi: Cotton shirt eða 481720",
			"editHsCode": "Breyta tollflokki",
			"hsCodeLabel": "Tollanúmer",
			"hsCodePlaceholder": "Dæmi: 620520",
			"search": "Leita",
			"cancel": "Hætta við",
			"manualEntry": "Handskrá tollanúmer",
			"backToSearch": "Til baka í leit",
			"continue": "Áfram",
			"resultsTitle": "Veldu tollflokk úr neðangreindum lista",
			"noResults": "Engir tollflokkar fundust. Prófaðu annað leitarorð.",
			"searchError": "Eitthvað fór úrskeiðis við leitina. Handskráðu tollanúmerið eða reyndu aftur.",
			"throttled": "Of margar leitir á stuttum tíma. Handskráðu tollanúmerið, eða bíddu í nokkrar mínútur og reyndu aftur.",
			"selectionRequired": "Þú þarft að velja tollflokk til að halda áfram.",
			"removeItem": "Fjarlægja hlut",
			"required": "Skylda að fylla út",
			"hsCodeInvalid": "Tollanúmer verður að vera 6 tölustafir"
		}
	},
	"step-info": {
		"address": "Heimilisfang",
		"address-cont": "Heimilisfang framhald",
		"address-required": "Skylda að fylla út",
		"addressed-to": "Berist til",
		"contact": "Tengiliður",
		"email": "Netfang",
		"email-format": "Netfang er ekki á réttu formi",
		"email-spell-warning": "Gæti verið innsláttarvilla í netfanginu ætti það að vera {{email}}",
		"email-undeliverable": "Netfang ekki til eða ekki hægt að senda á það",
		"email-invalid": "Nefang er ekki gilt",
		"email-required": "Skylda að fylla út",
		"field-required": "Skylda að fylla út",
		"info": "Upplýsingar",
		"max": "Of margir stafir",
		"name": "Nafn",
		"name-required": "Skylda að fylla út",
		"no-icelandic-letters": "Íslenskir stafir eru ekki leyfðir í netföngum",
		"phone": "Farsímanúmer",
		"genericPhone": "Símanúmer",
		"receiverPhone": "Farsímanúmer viðtakanda",
		"phone-info": "Ef farsímanúmer viðtakanda er bætt við fær hann skilaboð þegar sendingin er komin á áfangastað (á aðeins við um sendingar innanlands).",
		"shipment-phone-format-info": "Sláðu inn 6111111, +447911123456 eða 00447911123456.",
		"phone-country-search": "Leita að landi",
		"phone-min": "Símanúmerið verður að vera minnst sjö stafir",
		"phone-recipient-max": "Símanúmer má ekki vera lengra en fimmtán stafir",
		"phone-recipient-max7": "Símanúmer má ekki vera lengra en sjö stafir",
		"phone-required": "Skylda að fylla út",
		"mobile-format": "Símanúmer viðtakanda verður að vera farsímanúmer",
		"phone-format": "Símanúmer á vitlausu formi",
		"phone-international-prefix": "Ef símanúmerið er erlent þarf það að byrja á + eða 00.",
		"phone-sender-max": "Símanúmer má ekki vera lengra en sjö stafir",
		"phone-start": "Símanúmer verður að byrja á 4, 5, 6, 7 eða 8",
		"place": "Borg/Bær",
		"poscode-required": "Skylda að fylla út",
		"postcode": "Póstnúmer",
		"recipient-email-info": "Vinsamlegast sláðu inn netfang viðtakanda svo hægt sé að upplýsa viðkomandi um sendinguna. Ef þú veist ekki netfang viðtakanda getur þú slegið inn þitt eigið netfang.",
		"required-email-or-phone": "Skylda er að taka fram annaðhvort netfang eða símanúmer",
		"sender-foreign": "Sendandi er ekki með íslenska kennitölu",
		"social-id-required": "Skylda að fylla út",
		"ssn": "Kennitala",
		"senderSsn": "Kennitala sendanda",
		"ssn-min": "Kennitala verður að vera minnst 10 stafir",
		"ssn-max": "Kennitala má ekki vera meira en 10 stafir",
		"ssn-required": "Skylda að fylla út",
		"ssn-valid": "Kennitala er ekki rétt - Aðeins tölustafir eru leyfðir, ekkert bil eða bandstrik",
		"tooLong": "Of margir stafir",
		"zip-incorrect": "Póstnúmer ekki á réttu formi fyrir viðkomandi land",
		"saveRecipient": "Vista nýjan viðtakanda",
		"updateRecipient": "Uppfæra viðtakanda",
		"company": "Viltu kynna þér ",
		"insuranceTerms": "Ég hef lesið og samþykki <0>viðskiptaskilmála</0> Póstsins",
		"receiver-phone": "Símanúmer viðtakanda",
		"receiver-email": "Netfang viðtakanda",
		"mustHaveSSNWhenUS": "Verður að vera kennitala þegar sent er til Bandaríkjanna",
		"companySenderBusinessAccountInfo": "Fyrirtæki geta einungis sent sendingar til ESB-ríkja á Fyrirtækjasíðum. <0>Innskráning hér</0>",
		"requiresBusinessAccountForCompanySender": "Fyrirtæki verða að skrá sendingu til ESB-ríkis á Fyrirtækjasíðum. <0>Innskráning hér</0>"
	},
	"step-optional-services": {
		"account": "Reikningsnúmer",
		"account-required": "Skylda að fylla út",
		"account-type": "Höfuðbók",
		"account-type-length": "Höfuðbók verður að vera tveir stafir að lengd",
		"account-type-required": "Skylda að fylla út",
		"amount": "Upphæð (kr)",
		"amount-min": "Lágmarksgjald er 500 kr.",
		"amount-max": "Hámarksgjald er 3.000.000 kr.",
		"amount-required": "Skylda að fylla út",
		"amount-type": "Upphæð verður að vera tala",
		"bank": "Banki",
		"bank-info-incorrect": "Reikningsupplýsingar voru ekki á réttu formi",
		"bank-required": "Skylda að fylla út",
		"choose-optional-service": "Veldu viðbótarþjónustu",
		"min-amount": "Lágmarksgjald er 500 kr. sem jafngildir tryggingu fyrir 100 þús. krónur.",
		"optional-services-total": "Viðbótarþjónusta samtals",
		"only-numbers": "Aðeins tölur leyfilegar",
		"price-for-recipient": "(verð 300 kr.)",
		"recipient-cant-pay": "Viðtakandi getur ekki borgað fyrir erlendar sendingar, rekjanleg bréf eða sendingar í póstbox.",
		"reference": "Tilvísun póstkröfu",
		"reference-length": "Tilvísun má ekki vera lengri en sjö tölustafir",
		"reference-type": "Tilvísun er tekin fram með númeri",
		"ssn-recipient": "Kennitala reikningseiganda",
		"ssn-required": "Skylda að fylla út",
		"step-optional-services": "Viðbótarþjónustur",
		"total": "Samtals alls",
		"value": "Sláðu inn verðmæti innihalds",
		"who-pays": "Hver greiðir fyrir sendinguna?",
		"who-pays-required": "Skylda að fylla út"
	},
	"step-receipt": {
		"print": "Prenta fylgibréf",
		"register-shipment": "Skrá nýja sendingu",
		"success": "Skráning tókst",
		"trackingnumber": "Sendingarnúmer:",
		"text-copied": "Texti afritaður"
	},
	"step-shipment": {
		"choose-postbox": "Veldu póstbox",
		"choose-parcelpoint": "Veldu pakkaport",
		"choose-weight": "Áætluð þyngd og/eða rúmmál",
		"choose-weight-info": "Allar sendingar eru vigtaðar við móttöku og því er um áætlað verð að ræða miðað við gefnar forsendur.",
		"choose-weight-info-parcel-extended": " Athugaðu að þyngd er námunduð upp í næsta kíló.",
		"dont-know-weight": "Veit ekki þyngd",
		"dont-know-weight-info": "Aðeins er sýnt lægsta mögulega verð á þjónustum",
		"heavy-option": "Þyngri sending",
		"weight-unknown-info": "Aðeins sýnt lægsta verð á afhendingarleið",
		"round-up-text": "Námundaðu upp í næsta kíló til að fá réttara verð t.d. ef sending er 1,2 kg þá er valið 2 kg",
		"volume-question": "Viltu skrá rúmmál?",
		"volume-info": "Ef sendingin er stór getur verðið breyst",
		"max-letter-weight-short": "Hámarksþyngd 2000 g",
		"enter-weight-kg": "Sláðu inn þyngd í kg",
		"weight-placeholder": "Veldu þyngd",
		"golfset": "Ímyndaðu þér þyngdina á golfsetti",
		"no-services": "Engar þjónustur fundust fyrir gefin skilyrði.",
		"parcel-weight": "Skylda er að taka fram þyngd pakkans",
		"pot-of-milk": "Pottur af mjólk er samtals 1 kg",
		"recipient-pays": "Viðtakandi borgar",
		"recipient-pays-description": "Viðtakandi borgar gjöld. Kennitala sendanda þarf að vera skráð.",
		"service-option": "Skylda er að velja þjónustu",
		"service-option-postbox": "Skylda er að velja í hvaða póstbox pakkinn verður sóttur",
		"service-option-parcelpoint": "Skylda er að velja í hvaða pakkaport pakkinn verður sóttur",
		"sheep": "Ær eru að meðaltali 60-70 kg",
		"step-shipment": "Sending",
		"is-heavy": "Ég er með þyngri sendingu",
		"choose-service": "Veldu afhendingarleið",
		"postbox-unavailable": "Einungis í boði ef senda á einn pakka.",
		"recipientPaysPostbox": "Athugið, ef viðtakandi á að borga gjöld er ekki hægt að póstleggja sendinguna í póstbox.",
		"requires-login": "Til að velja þennan möguleika þarf að <0>skrá sig hér</0> inn á Mínar síður",
		"foodWarning": "Athugið! Óheimilt er að senda fersk matvæli á milli landa t.d hangikjöt og lax, sjá nánar hérna",
		"weight": "Þyngd",
		"round-up-weight": "Námundaðu upp í næsta kíló til að fá réttara verð t.d. ef sending er 1,2kg er skráð 2kg. Lágmarksþyngd er 1kg.",
		"enter-weight-description": "Til að fá nákvæmara verð getur þú einnig fyllt út rúmmál sendingarinnar.",
		"size-matters": "Stærð getur haft áhrif á verð",
		"max-letter-weight": "Hámarksþyngd 2000 g. Upplýsingar um verðskrá fyrir órekjanleg bréf má finna <0>hér</0>."
	},
	"step-type": {
		"choose-zip-code": "Veldu póstnúmer",
		"country-required-text": "Skylda að fylla út",
		"delivering-from": "Senda frá",
		"delivering-to": "Senda til",
		"number-of-parcels": "Fjöldi:",
		"parcel": "Pakki",
		"parcel-count-required-text": "Skylda að fylla út",
		"parcel-disabled-text": "Einungis einn pakki er leyfilegur fyrir sendingar út úr landi",
		"register-shipment": "Skrá sendingu",
		"registered-letter": "Bréf",
		"service-required-text": "Skylda að fylla út",
		"what-are-you-delivering": "Hvað ertu að senda",
		"error-countries": "Gat ekki sótt lönd",
		"error-heading": "Eitthvað fór úrskeiðis",
		"where-are-you-delivering-to": "Hvert ertu að senda",
		"zip-required-text": "Skylda að fylla út",
		"type": "Tegund",
		"moreThan1": "Ath: Einungis er hægt að skrá einn pakka ef Póstbox er valið.",
		"useRecipient": "Nota vistaðan viðtakanda..",
		"foreignWarning": "Tafir gætu orðið á sendingum til allra landa.",
		"countryClosed": "Því miður er ekki hægt að senda til þessa lands í augnablikinu."
	},
	"register": "Sparaðu þér 770 kr. skráningargjald með því að forskrá sendinguna þína hér.",
	"whoToPay": "Hverjum á að greiða",
	"required": "Skylda að fylla út",
	"explanation-logged-in-1": "Ef þú ert með greiðslukort á skrá geturðu afhent sendinguna í Póstbox eða hraðafgreiðslu á völdum pósthúsum. Annars er hægt að afhenda og greiða fyrir sendinguna hjá gjaldkera á pósthúsum.",
	"explanation-logged-in-2": "Þú verður leidd/ur í gegnum ferlið þar sem þú gefur upp upplýsingar um viðtakanda, þyngd sendingar, velur afhendingarmáta og gefur leyfi fyrir sjálfvirkri greiðslu.",
	"explanation-open-web-1": "Ef þú skráir þig inn á mínar síður og skráir þig í sjálfvirkar greiðslur geturðu skutlað sendingunni beint í Póstbox eða nýtt þér hraðafgreiðslu á völdum pósthúsum. Annars er hægt að afhenda og greiða fyrir sendinguna hjá gjaldkera á pósthúsum",
	"explanation-open-web-2": "Þú verður leidd/ur í gegnum ferlið þar sem þú gefur upp upplýsingar um viðtakanda, þyngd sendingar og velur afhendingarmáta.",
	"barcodeInfo": "Þessa sendingu þarf að póstleggja og greiða á pósthúsi.",
	"barcodeInfoPaymentAuthorized": "Þessa sendingu má póstleggja í póstboxi eða á pósthúsi og verður gjaldfærð af skráðu greiðslukorti.",
	"youHaveToAccept": "Það á eftir að haka við samþykki"
}
